// index.js - Fixed Navbar Component
import React from 'react';
import {
  Nav,
  NavLink,
  NavbarContainer,
  Span,
  NavLogo,
  NavItems,
  GitHubButton,
  LeetcodeButton,
  ButtonContainer,
  MobileIcon,
  MobileMenu,
  MobileLink,
} from './NavbarStyledComponent';
import { FaBars } from 'react-icons/fa';
import { Bio, handleRedirect } from '../../data/constants';
import { useTheme } from 'styled-components';

const Navbar = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const theme = useTheme();
  return (
    <Nav>
      <NavbarContainer>
        <NavLogo></NavLogo>
        <MobileIcon>
          <FaBars
            onClick={() => {
              setIsOpen(!isOpen);
            }}
          />
        </MobileIcon>
        <NavItems>
          <NavLink onClick={e => handleRedirect(e, '#about', setIsOpen)}>About</NavLink>
          <NavLink onClick={e => handleRedirect(e, '#skills', setIsOpen)}>Skills</NavLink>
          <NavLink onClick={e => handleRedirect(e, '#experience', setIsOpen)}>Experience</NavLink>
          <NavLink onClick={e => handleRedirect(e, '#projects', setIsOpen)}>Projects</NavLink>
          <NavLink onClick={e => handleRedirect(e, '#contact', setIsOpen)}>Contact</NavLink>
          <GitHubButton onClick={() => window.open(Bio.github, '_blank')}>GitHub</GitHubButton>

          <GitHubButton onClick={() => window.open(Bio.leetcode, '_blank')}>LeetCode</GitHubButton>

          <GitHubButton onClick={() => window.open(Bio.linkedin, '_blank')}>LinkedIn</GitHubButton>
        </NavItems>
        <ButtonContainer></ButtonContainer>
        {isOpen && (
          <MobileMenu isOpen={isOpen}>
            <MobileLink
              onClick={e => {
                e.preventDefault();
                handleRedirect(e, '#about', setIsOpen);
                setIsOpen(!isOpen);
              }}
            >
              About
            </MobileLink>
            <MobileLink
              onClick={e => {
                e.preventDefault();
                handleRedirect(e, '#skills', setIsOpen);
                setIsOpen(!isOpen);
              }}
            >
              Skills
            </MobileLink>
            <MobileLink
              onClick={e => {
                e.preventDefault();
                handleRedirect(e, '#experience', setIsOpen);
                setIsOpen(!isOpen);
              }}
            >
              Experience
            </MobileLink>
            <MobileLink
              onClick={e => {
                e.preventDefault();
                handleRedirect(e, '#projects', setIsOpen);
                setIsOpen(!isOpen);
              }}
            >
              Projects
            </MobileLink>
            <MobileLink
              onClick={e => {
                e.preventDefault();
                handleRedirect(e, '#contact', setIsOpen);
                setIsOpen(!isOpen);
              }}
            >
              Contact
            </MobileLink>
            <GitHubButton
              style={{
                padding: '0px 8px',
                background: `${theme.primary}`,
                color: 'white',
                width: 'max-content',
              }}
              onClick={e => {
                window.open(Bio.github, '_blank');
                setIsOpen(false);
              }}
            >
              Github
            </GitHubButton>

            <GitHubButton
              style={{
                padding: '0px 7px',
                background: `${theme.primary}`,
                color: 'white',
                width: 'max-content',
              }}
              onClick={e => {
                window.open(Bio.leetcode, '_blank');
                setIsOpen(false);
              }}
            >
              LeetCode
            </GitHubButton>
            <GitHubButton
              style={{
                padding: '0px 7px',
                background: `${theme.primary}`,
                color: 'white',
                width: 'max-content',
              }}
              onClick={e => {
                window.open(Bio.linkedin, '_blank');
                setIsOpen(false);
              }}
            >
              LinkedIn
            </GitHubButton>
          </MobileMenu>
        )}
      </NavbarContainer>
    </Nav>
  );
};

export default Navbar;
